(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ux-ai-outfit-studio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var MAX_FILE_BYTES = 10 * 1024 * 1024;
    var ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
    var OUTPUT_W = 864;
    var OUTPUT_H = 1296;

    /* ============================================================
       Provider abstraction - add new providers here only.
       Each provider exposes generate({ proxyUrl, modelImage,
       garmentImage, category, mode, onProgress }) -> Promise<url>
    ============================================================ */
    var AI_PROVIDERS = {
      fashn: {
        ready: true,
        generate: function (opts) {
          return fetch(opts.proxyUrl.replace(/\/$/, '') + '/generate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              provider: 'fashn',
              model_image: opts.modelImage,
              garment_image: opts.garmentImage,
              category: opts.category,
              mode: opts.mode,
            }),
          })
            .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
            .then(function (result) {
              if (!result.ok || !result.data || !result.data.id) {
                var msg = (result.data && (result.data.message || result.data.error)) || 'Could not start generation.';
                throw new Error(typeof msg === 'string' ? msg : 'Could not start generation.');
              }
              return pollFashn(opts.proxyUrl, result.data.id, opts.onProgress, opts.mode);
            });
        },
      },
      gemini: { ready: false, generate: function () { return Promise.reject(new Error('Gemini provider is not connected yet.')); } },
      openai: { ready: false, generate: function () { return Promise.reject(new Error('OpenAI provider is not connected yet.')); } },
      kling: { ready: false, generate: function () { return Promise.reject(new Error('Kling AI provider is not connected yet.')); } },
    };

    function sleep(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }

    function expectedDurationMs(mode) {
      if (mode === 'performance') return 6000;
      if (mode === 'quality') return 17000;
      return 10000; // balanced
    }

    function pollFashn(proxyUrl, id, onProgress, mode) {
      var start = Date.now();
      var timeoutMs = 60000;
      var expected = expectedDurationMs(mode);

      function tick() {
        var elapsed = Date.now() - start;
        if (onProgress) {
          var eased = 1 - Math.pow(1 - Math.min(elapsed / expected, 1), 2);
          onProgress(Math.min(92, Math.round(eased * 92)));
        }
      }
      var progressTimer = setInterval(tick, 250);
      tick();

      function poll() {
        if (Date.now() - start > timeoutMs) {
          clearInterval(progressTimer);
          return Promise.reject(new Error('Generation timed out. Please try again.'));
        }
        return fetch(proxyUrl.replace(/\/$/, '') + '/status/' + id)
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status === 'completed' && data.output && data.output[0]) {
              clearInterval(progressTimer);
              if (onProgress) onProgress(100);
              return data.output[0];
            }
            if (data.status === 'failed') {
              clearInterval(progressTimer);
              var msg = (data.error && data.error.message) || 'Generation failed.';
              throw new Error(msg);
            }
            return sleep(1200).then(poll);
          });
      }
      return poll();
    }

    /* ============================================================
       Per-instance wiring
    ============================================================ */
    function initTryOn(root) {
      var tryon = root.querySelector('[data-ux-ai-tryon]');
      if (!tryon) return;

      var proxyUrl = root.dataset.proxyUrl;
      var provider = root.dataset.provider || 'fashn';
      var mode = root.dataset.mode || 'balanced';
      var category = root.dataset.category || 'auto';
      var garmentImage = root.dataset.garmentImage;

      var steps = {};
      tryon.querySelectorAll('[data-ux-ai-step]').forEach(function (el) {
        steps[el.dataset.uxAiStep] = el;
      });

      function showStep(name) {
        Object.keys(steps).forEach(function (key) {
          steps[key].hidden = key !== name;
        });
      }

      var fileInput = tryon.querySelector('[data-ux-ai-file-input]');
      var uploadTrigger = tryon.querySelector('[data-ux-ai-upload-trigger]');
      var cameraTrigger = tryon.querySelector('[data-ux-ai-camera]');
      var uploadError = tryon.querySelector('[data-ux-ai-upload-error]');

      var cropFrame = tryon.querySelector('[data-ux-ai-crop-frame]');
      var cropCanvas = tryon.querySelector('[data-ux-ai-crop-canvas]');
      var cropCtx = cropCanvas ? cropCanvas.getContext('2d') : null;
      var zoomInput = tryon.querySelector('[data-ux-ai-zoom]');
      var confirmCropBtn = tryon.querySelector('[data-ux-ai-confirm-crop]');
      var retakeBtn = tryon.querySelector('[data-ux-ai-retake]');

      var progressFill = tryon.querySelector('[data-ux-ai-progress-fill]');
      var progressText = tryon.querySelector('[data-ux-ai-progress-text]');

      var resultImg = tryon.querySelector('[data-ux-ai-result-img]');
      var compareWrap = tryon.querySelector('[data-ux-ai-compare]');
      var compareAfter = tryon.querySelector('[data-ux-ai-compare-after]');
      var compareBeforeWrap = tryon.querySelector('[data-ux-ai-compare-before-wrap]');
      var compareBefore = tryon.querySelector('[data-ux-ai-compare-before]');
      var compareDivider = tryon.querySelector('[data-ux-ai-compare-divider]');
      var toggleCompareBtn = tryon.querySelector('[data-ux-ai-toggle-compare]');
      var downloadBtn = tryon.querySelector('[data-ux-ai-download]');
      var againBtn = tryon.querySelector('[data-ux-ai-again]');

      var errorMessage = tryon.querySelector('[data-ux-ai-error-message]');
      var retryBtn = tryon.querySelector('[data-ux-ai-retry]');

      var state = { rawImage: null, croppedDataUrl: null, resultUrl: null, pan: { x: 0, y: 0 }, zoom: 1, imgEl: null };

      function resetError() {
        if (uploadError) uploadError.textContent = '';
      }

      function handleFile(file) {
        resetError();
        if (!file) return;
        if (ACCEPTED_TYPES.indexOf(file.type) === -1) {
          if (uploadError) uploadError.textContent = 'Please choose a JPG, PNG or WEBP image.';
          return;
        }
        if (file.size > MAX_FILE_BYTES) {
          if (uploadError) uploadError.textContent = 'That image is larger than 10MB. Please choose a smaller one.';
          return;
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          var img = new Image();
          img.onload = function () {
            state.imgEl = img;
            state.pan = { x: 0, y: 0 };
            state.zoom = 1;
            if (zoomInput) zoomInput.value = '1';
            showStep('crop');
            requestAnimationFrame(drawCrop);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      /* ---- Crop canvas: drag to pan, slider to zoom ---- */
      function drawCrop() {
        if (!cropCtx || !state.imgEl) return;
        var rect = cropFrame.getBoundingClientRect();
        cropCanvas.width = rect.width;
        cropCanvas.height = rect.height;

        var img = state.imgEl;
        var coverScale = Math.max(rect.width / img.width, rect.height / img.height);
        var scale = coverScale * state.zoom;
        var drawW = img.width * scale;
        var drawH = img.height * scale;

        var maxPanX = Math.max(0, (drawW - rect.width) / 2);
        var maxPanY = Math.max(0, (drawH - rect.height) / 2);
        state.pan.x = Math.max(-maxPanX, Math.min(maxPanX, state.pan.x));
        state.pan.y = Math.max(-maxPanY, Math.min(maxPanY, state.pan.y));

        var dx = (rect.width - drawW) / 2 + state.pan.x;
        var dy = (rect.height - drawH) / 2 + state.pan.y;

        cropCtx.clearRect(0, 0, rect.width, rect.height);
        cropCtx.drawImage(img, dx, dy, drawW, drawH);
      }

      if (cropFrame) {
        var dragging = false;
        var lastX = 0, lastY = 0;

        function pointerDown(e) {
          dragging = true;
          var p = e.touches ? e.touches[0] : e;
          lastX = p.clientX; lastY = p.clientY;
        }
        function pointerMove(e) {
          if (!dragging) return;
          var p = e.touches ? e.touches[0] : e;
          state.pan.x += p.clientX - lastX;
          state.pan.y += p.clientY - lastY;
          lastX = p.clientX; lastY = p.clientY;
          drawCrop();
          if (e.cancelable) e.preventDefault();
        }
        function pointerUp() { dragging = false; }

        cropFrame.addEventListener('mousedown', pointerDown);
        cropFrame.addEventListener('touchstart', pointerDown, { passive: true });
        window.addEventListener('mousemove', pointerMove);
        window.addEventListener('touchmove', pointerMove, { passive: false });
        window.addEventListener('mouseup', pointerUp);
        window.addEventListener('touchend', pointerUp);
        window.addEventListener('resize', drawCrop);
      }

      if (zoomInput) {
        zoomInput.addEventListener('input', function () {
          state.zoom = parseFloat(zoomInput.value) || 1;
          drawCrop();
        });
      }

      if (confirmCropBtn) {
        confirmCropBtn.addEventListener('click', function () {
          var out = document.createElement('canvas');
          out.width = OUTPUT_W;
          out.height = OUTPUT_H;
          var ctx = out.getContext('2d');

          var rect = cropFrame.getBoundingClientRect();
          var scaleToOutput = OUTPUT_W / rect.width;
          var img = state.imgEl;
          var coverScale = Math.max(rect.width / img.width, rect.height / img.height);
          var scale = coverScale * state.zoom;
          var drawW = img.width * scale * scaleToOutput;
          var drawH = img.height * scale * scaleToOutput;
          var dx = ((rect.width - (img.width * scale)) / 2 + state.pan.x) * scaleToOutput;
          var dy = ((rect.height - (img.height * scale)) / 2 + state.pan.y) * scaleToOutput;

          ctx.drawImage(img, dx, dy, drawW, drawH);
          state.croppedDataUrl = out.toDataURL('image/jpeg', 0.9);
          startGeneration(root, { proxyUrl: proxyUrl, provider: provider, mode: mode, category: category, garmentImage: garmentImage }, state, {
            showStep: showStep, progressFill: progressFill, progressText: progressText,
            resultImg: resultImg, compareAfter: compareAfter, compareBefore: compareBefore,
            errorMessage: errorMessage,
          });
        });
      }

      if (retakeBtn) {
        retakeBtn.addEventListener('click', function () {
          state.imgEl = null;
          showStep('upload');
          if (fileInput) fileInput.value = '';
        });
      }

      if (uploadTrigger && fileInput) {
        uploadTrigger.addEventListener('click', function () { fileInput.click(); });
      }
      if (cameraTrigger && fileInput) {
        cameraTrigger.addEventListener('click', function () {
          openCamera(function (file) {
            if (file) handleFile(file);
          }, function () {
            fileInput.setAttribute('capture', 'user');
            fileInput.click();
          });
        });
      }
      if (fileInput) {
        fileInput.addEventListener('change', function () { handleFile(fileInput.files && fileInput.files[0]); });
      }

      if (retryBtn) {
        retryBtn.addEventListener('click', function () { showStep('upload'); });
      }

      if (againBtn) {
        againBtn.addEventListener('click', function () {
          if (state.imgEl) {
            showStep('crop');
            requestAnimationFrame(drawCrop);
          } else {
            showStep('upload');
          }
        });
      }

      if (toggleCompareBtn) {
        toggleCompareBtn.addEventListener('click', function () {
          var showing = !compareWrap.hidden;
          compareWrap.hidden = showing;
          tryon.querySelector('[data-ux-ai-result-single]').hidden = !showing;
        });
      }

      if (downloadBtn) {
        downloadBtn.addEventListener('click', function () {
          if (!state.resultUrl) return;
          var a = document.createElement('a');
          a.href = state.resultUrl;
          a.download = 'urbanex-tryon.png';
          a.target = '_blank';
          a.rel = 'noopener';
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
      }

      if (compareDivider && compareWrap) {
        var dragCompare = false;
        function setDivider(pct) {
          pct = Math.max(0, Math.min(100, pct));
          compareDivider.style.left = pct + '%';
          compareBeforeWrap.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        }
        compareDivider.addEventListener('mousedown', function () { dragCompare = true; });
        window.addEventListener('mouseup', function () { dragCompare = false; });
        window.addEventListener('mousemove', function (e) {
          if (!dragCompare) return;
          var rect = compareWrap.getBoundingClientRect();
          setDivider(((e.clientX - rect.left) / rect.width) * 100);
        });
      }
    }

    function startGeneration(root, opts, state, ui) {
      resetProxyOrShow(root, opts, function () {
        ui.showStep('generating');
        ui.errorMessage.textContent = '';

        var provider = AI_PROVIDERS[opts.provider] || AI_PROVIDERS.fashn;
        if (!provider.ready) {
          ui.errorMessage.textContent = provider === AI_PROVIDERS.fashn ? 'AI try-on is not configured yet.' : 'This AI provider is not connected yet.';
          ui.showStep('error');
          return;
        }

        provider
          .generate({
            proxyUrl: opts.proxyUrl,
            modelImage: state.croppedDataUrl,
            garmentImage: opts.garmentImage,
            category: opts.category,
            mode: opts.mode,
            onProgress: function (pct) {
              if (ui.progressFill) ui.progressFill.style.width = pct + '%';
              if (ui.progressText) ui.progressText.textContent = 'Generating... ' + pct + '%';
            },
          })
          .then(function (resultUrl) {
            state.resultUrl = resultUrl;
            if (ui.resultImg) ui.resultImg.src = resultUrl;
            if (ui.compareAfter) ui.compareAfter.querySelector('img').src = resultUrl;
            if (ui.compareBefore) ui.compareBefore.src = state.croppedDataUrl;
            ui.showStep('result');
          })
          .catch(function (err) {
            ui.errorMessage.textContent = (err && err.message) || 'Something went wrong. Please try again.';
            ui.showStep('error');
          });
      });
    }

    function resetProxyOrShow(root, opts, proceed) {
      if (!opts.proxyUrl) {
        var tryon = root.querySelector('[data-ux-ai-tryon]');
        var errStep = tryon.querySelector('[data-ux-ai-step="error"]');
        var errMsg = tryon.querySelector('[data-ux-ai-error-message]');
        Object.keys({}).length; // no-op
        tryon.querySelectorAll('[data-ux-ai-step]').forEach(function (el) { el.hidden = el.dataset.uxAiStep !== 'error'; });
        if (errMsg) errMsg.textContent = 'AI try-on isn\'t connected yet - add a proxy endpoint URL in the section settings.';
        return;
      }
      proceed();
    }

    /* ---- Camera (getUserMedia with graceful fallback) ---- */
    function openCamera(onCapture, onFallback) {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        onFallback();
        return;
      }
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: 'user' } })
        .then(function (stream) {
          var dialog = document.createElement('dialog');
          dialog.style.cssText = 'border:0;padding:0;border-radius:16px;overflow:hidden;max-width:420px;width:92vw;';
          var video = document.createElement('video');
          video.autoplay = true;
          video.playsInline = true;
          video.style.cssText = 'display:block;width:100%;height:auto;';
          var bar = document.createElement('div');
          bar.style.cssText = 'display:flex;justify-content:center;gap:10px;padding:14px;background:#111;';
          var shootBtn = document.createElement('button');
          shootBtn.type = 'button';
          shootBtn.textContent = 'Capture';
          shootBtn.style.cssText = 'padding:10px 20px;border-radius:999px;border:0;background:#fff;font-weight:700;cursor:pointer;';
          var cancelBtn = document.createElement('button');
          cancelBtn.type = 'button';
          cancelBtn.textContent = 'Cancel';
          cancelBtn.style.cssText = 'padding:10px 20px;border-radius:999px;border:1px solid #fff;background:transparent;color:#fff;cursor:pointer;';

          bar.appendChild(cancelBtn);
          bar.appendChild(shootBtn);
          dialog.appendChild(video);
          dialog.appendChild(bar);
          document.body.appendChild(dialog);
          video.srcObject = stream;
          dialog.showModal();

          function cleanup() {
            stream.getTracks().forEach(function (t) { t.stop(); });
            dialog.close();
            dialog.remove();
          }

          shootBtn.addEventListener('click', function () {
            var canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            canvas.getContext('2d').drawImage(video, 0, 0);
            canvas.toBlob(function (blob) {
              cleanup();
              onCapture(new File([blob], 'camera-photo.jpg', { type: 'image/jpeg' }));
            }, 'image/jpeg', 0.92);
          });
          cancelBtn.addEventListener('click', cleanup);
          dialog.addEventListener('cancel', cleanup);
        })
        .catch(function () { onFallback(); });
    }

    /* ============================================================
       Complete Your Look: quick add
    ============================================================ */
    function initQuickAdd(root) {
      root.querySelectorAll('[data-ux-ai-card]').forEach(function (card) {
        var quickAddBtn = card.querySelector('[data-ux-ai-quick-add]');
        var variantPicker = card.querySelector('[data-ux-ai-variant-picker]');
        if (!quickAddBtn) return;

        var selectedVariantId = quickAddBtn.dataset.defaultVariantId;
        var isMultiVariant = quickAddBtn.dataset.multiVariant === 'true';

        if (variantPicker) {
          variantPicker.querySelectorAll('[data-ux-ai-variant-option]').forEach(function (pill) {
            pill.addEventListener('click', function () {
              variantPicker.querySelectorAll('[data-ux-ai-variant-option]').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
              pill.setAttribute('aria-pressed', 'true');
              selectedVariantId = pill.dataset.variantId;
              addToCart(quickAddBtn, selectedVariantId);
            });
          });
        }

        quickAddBtn.addEventListener('click', function () {
          if (isMultiVariant && variantPicker) {
            variantPicker.hidden = !variantPicker.hidden;
            return;
          }
          addToCart(quickAddBtn, selectedVariantId);
        });
      });
    }

    function addToCart(button, variantId) {
      if (!variantId || button.disabled) return;
      var label = button.querySelector('[data-ux-ai-quick-add-label]');
      var originalText = label ? label.textContent : '';
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error((result.data && result.data.description) || 'Could not add to cart.');
          if (label) label.textContent = 'Added';
          button.dataset.state = 'added';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          setTimeout(function () {
            button.disabled = false;
            button.dataset.state = '';
            if (label) label.textContent = originalText;
          }, 1800);
        })
        .catch(function () {
          if (label) label.textContent = 'Try again';
          button.disabled = false;
          setTimeout(function () { if (label) label.textContent = originalText; }, 1800);
        });
    }

    /* ============================================================
       Style combo preview
    ============================================================ */
    function initCombos(root) {
      var dataEl = root.querySelector('[data-ux-ai-combo-data]');
      var previewPanel = root.querySelector('[data-ux-ai-combo-preview]');
      if (!dataEl || !previewPanel) return;

      var productMap = {};
      try {
        var parsed = JSON.parse(dataEl.textContent);
        (parsed.products || []).forEach(function (p) { productMap[p.id] = p; });
      } catch (e) { return; }

      var titleEl = previewPanel.querySelector('[data-ux-ai-combo-preview-title]');
      var gridEl = previewPanel.querySelector('[data-ux-ai-combo-preview-grid]');
      var closeBtn = previewPanel.querySelector('[data-ux-ai-combo-close]');

      root.querySelectorAll('[data-ux-ai-combo]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var active = pill.getAttribute('aria-pressed') === 'true';
          root.querySelectorAll('[data-ux-ai-combo]').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });

          if (active) {
            previewPanel.hidden = true;
            return;
          }
          pill.setAttribute('aria-pressed', 'true');

          var ids = (pill.dataset.comboProducts || '').split(',').filter(Boolean);
          gridEl.innerHTML = '';
          ids.forEach(function (id) {
            var p = productMap[id];
            if (!p) return;
            var a = document.createElement('a');
            a.href = p.url;
            a.className = 'ux-ai__combo-preview-item';
            var img = document.createElement('img');
            img.src = p.image;
            img.alt = p.title;
            img.loading = 'lazy';
            var name = document.createElement('p');
            name.textContent = p.title;
            var price = document.createElement('p');
            price.textContent = p.price;
            price.style.opacity = '0.6';
            a.appendChild(img);
            a.appendChild(name);
            a.appendChild(price);
            gridEl.appendChild(a);
          });

          titleEl.textContent = pill.dataset.comboName;
          previewPanel.hidden = false;
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          previewPanel.hidden = true;
          root.querySelectorAll('[data-ux-ai-combo]').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        });
      }
    }

    function init() {
      document.querySelectorAll('[data-ux-ai-outfit-studio]').forEach(function (root) {
        initTryOn(root);
        initQuickAdd(root);
        initCombos(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
